import { render } from "./NudesSelect.vue?vue&type=template&id=5508c86e&scoped=true"
import script from "./NudesSelect.vue?vue&type=script&lang=js"
export * from "./NudesSelect.vue?vue&type=script&lang=js"

import "./NudesSelect.vue?vue&type=style&index=0&id=5508c86e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5508c86e"]])

export default __exports__